{
  "home": "Home",
  "activities": {
    "activities": "Activities",
    "rydinFulfillment": "RydinFulfillment",
    "importOrders": "import-orders"
  },
  "reports": {
    "reports": "Reports",
    "salesAndCitationsReports": "SalesAndCitationsReports",
    "financialReports": "FinancialReports"
  },
  "settings": {
    "settings": "settings",
    "defineSecurityGroups": "DefineSecurityGroups",
    "defineManageClientUsers": "DefineManageClientUsers"
  },
  "helpFeature": {
    "helpFeature": "HelpFeature"
  },
  "SystemAdmin": {
    "systemAdmin": "SystemAdmin"
  }
}
